// Angular
import { EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
// State
import { Store } from '@ngxs/store';
// Action
import {
	AppInformationService,
	CLASS_APP_KEY,
	CLASS_ORG_ID,
	LoadUIConfig,
	UpdateToken
} from '@cv-invision/core';
// Other
import { first } from 'rxjs/operators';

export class AppConfigBootstrapModel {

	constructor(
		protected readonly eventService: PublicEventsService,
		protected appInfo: AppInformationService,
		protected store: Store
	) {
		this.onEventLoad();
		this.loadUIConfig();
	}

	/**
	 * Listener to On Event Loads
	 * @private
	 */
	private onEventLoad(): void {
		this.eventService
			.registerForEvents()
			// .pipe(filter((notification) => notification.type === EventTypes.ConfigLoaded))
			.subscribe((oidcEvent) => {
				const eventValue = oidcEvent.value;

				switch (oidcEvent.type) {
					case EventTypes.NewAuthenticationResult:
						console.log('Auth Change', oidcEvent);
						if (eventValue.isRenewProcess && eventValue.isAuthenticated) {
							const accessToken = this.appInfo.getOidcToken();
							this.store.dispatch(new UpdateToken(accessToken));
						}
						break;
				}
			});
	}

	/**
	 * Initiate UI Configuration
	 */
	public loadUIConfig(): void {
		const userKeyIndex = 0;
		const appKeyIndex = 1;
		this.store
			.select(s => [s.user, s])
			.pipe(
				first((nextState: any) =>
					nextState[userKeyIndex][CLASS_ORG_ID] && nextState[appKeyIndex][CLASS_APP_KEY][this.appInfo.appName]
				),
			)
			.subscribe((nextState: any) => {
				if (nextState) {
					this.store.dispatch(new LoadUIConfig(nextState[userKeyIndex][CLASS_ORG_ID], this.appInfo.appName));
				}
			});
	}
}
